import type {
  HistoryDateFilterItem,
  HistoryDateFilterSelectItem,
} from '@/shared/types';

const buildPeriodSelectOptions = (
  options: HistoryDateFilterItem[]
): HistoryDateFilterSelectItem[] => {
  return options.map(option => ({
    value: option.datefilter,
    name: option.name,
  }));
};

export { buildPeriodSelectOptions };
